import React from "react";
import Header from '../Header/Header'
import Banner from '../Banner/Banner'
import Features from '../Features/Features';
import Protocol from '../Protocol/Protocol';
import Videos from '../Videos/Videos';
import TeamAndAdvisors from '../TeamAndAdvisors/TeamAndAdvisors';
import Advisor from '../Advisors/Advisors';
import Footer from '../Footer/Footer';

function Landing() {
	return (
		<React.Fragment>
			<Header />
			<Banner />
			<Features  />
			<Videos />
			<Protocol />
			<TeamAndAdvisors />
			<Footer />
		</React.Fragment>
	);
}
export default Landing;